import React, { useState } from "react";
import DateRangeSelector from "../components/DateRangeSelector";
const today = new Date().toISOString().slice(0, 10);
const DashboardFilters = ({ onDateChange }) => { const [range,setRange]=useState({startDate:today,endDate:today});const apply=selected=>{setRange(selected);onDateChange?.(selected)};return <DateRangeSelector startDate={range.startDate} endDate={range.endDate} onApply={apply} label="Generate Sale Summary" maxDate={new Date()}/>; };
export default DashboardFilters;
